import type { SyntheticEvent } from 'react';

export const markImageLoaded = (e: SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.setAttribute('data-loaded', 'true');
};

export const markImageError = (e: SyntheticEvent<HTMLImageElement>) => {
  e.currentTarget.setAttribute('data-loaded', 'true');
  e.currentTarget.setAttribute('data-error', 'true');
};
